import React, { Fragment, lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
const OnboardingFlow = lazy(() => import('../pages/OnboardingFlow').then(m => ({
  default: m.OnboardingFlow
})));
const DashboardPage = lazy(() => import('../pages/DashboardPage').then(m => ({
  default: m.DashboardPage
})));
const UploadPage = lazy(() => import('../pages/UploadPage').then(m => ({
  default: m.UploadPage
})));
const AnalysisPage = lazy(() => import('../pages/AnalysisPage').then(m => ({
  default: m.AnalysisPage
})));
const ProfilePage = lazy(() => import('../pages/ProfilePage').then(m => ({
  default: m.ProfilePage
})));
const AllScansPage = lazy(() => import('../pages/AllScansPage').then(m => ({
  default: m.AllScansPage
})));
const SettingsPage = lazy(() => import('../pages/SettingsPage').then(m => ({
  default: m.SettingsPage
})));
const MonthlyReportPage = lazy(() => import('../pages/MonthlyReportPage').then(m => ({
  default: m.MonthlyReportPage
})));
const PremiumToolsPage = lazy(() => import('../pages/PremiumToolsPage').then(m => ({
  default: m.PremiumToolsPage
})));
const MessageRewriterPage = lazy(() => import('../pages/MessageRewriterPage').then(m => ({
  default: m.MessageRewriterPage
})));
const PaymentPage = lazy(() => import('../pages/PaymentPage').then(m => ({
  default: m.PaymentPage
})));
export const protectedRoutes = <Fragment data-id="element-10809">
    <Route path="/onboarding" element={<ProtectedRoute data-id="element-10811">
          <OnboardingFlow data-id="element-10812" />
        </ProtectedRoute>} data-id="element-10810" />
    <Route path="/dashboard" element={<ProtectedRoute data-id="element-10814">
          <DashboardPage data-id="element-10815" />
        </ProtectedRoute>} data-id="element-10813" />
    <Route path="/upload" element={<ProtectedRoute data-id="element-10817">
          <UploadPage data-id="element-10818" />
        </ProtectedRoute>} data-id="element-10816" />
    <Route path="/analysis" element={<ProtectedRoute data-id="element-10820">
          <AnalysisPage data-id="element-10821" />
        </ProtectedRoute>} data-id="element-10819" />
    <Route path="/tools" element={<ProtectedRoute data-id="element-10823">
          <PremiumToolsPage data-id="element-10824" />
        </ProtectedRoute>} data-id="element-10822" />
    <Route path="/tools/rewriter" element={<ProtectedRoute data-id="element-10826">
          <MessageRewriterPage data-id="element-10827" />
        </ProtectedRoute>} data-id="element-10825" />
    <Route path="/premium-tools" element={<ProtectedRoute data-id="element-10829">
          <PremiumToolsPage data-id="element-10830" />
        </ProtectedRoute>} data-id="element-10828" />
    <Route path="/profile" element={<ProtectedRoute data-id="element-10832">
          <ProfilePage data-id="element-10833" />
        </ProtectedRoute>} data-id="element-10831" />
    <Route path="/all-scans" element={<ProtectedRoute data-id="element-10835">
          <AllScansPage data-id="element-10836" />
        </ProtectedRoute>} data-id="element-10834" />
    <Route path="/monthly-report" element={<ProtectedRoute data-id="element-10838">
          <MonthlyReportPage data-id="element-10839" />
        </ProtectedRoute>} data-id="element-10837" />
    <Route path="/settings" element={<ProtectedRoute data-id="element-10841">
          <SettingsPage data-id="element-10842" />
        </ProtectedRoute>} data-id="element-10840" />
    <Route path="/payment" element={<ProtectedRoute data-id="element-10844">
          <PaymentPage data-id="element-10845" />
        </ProtectedRoute>} data-id="element-10843" />
  </Fragment>;